import { Route, Routes } from "react-router-dom"
import LoginPage from "./login"
import Dashboard from "./dashboard"
import { PrivateRoute } from "../components/templates/PrivateRoute"
import SignupPage from "./signup"
import { CruiseDetails } from "./cruiseDetails"
import { CruiseList } from "./cruiseList"
import { QuoteRequest } from "./quoteRequest"
import { StatusScreen } from "../components/templates/StatusScreen"
import { JoinTripConfirmation } from "./joinTripConfirmation"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route path="/trips/:tripId" element={<CruiseList />} />
      <Route path="/trips/:tripId/cruises/:cruiseId" element={<CruiseDetails />} />
      <Route path="/trips/:tripId/cruises/:cruiseId/quote/:token?" element={<QuoteRequest />} />
      <Route path="/trips/:tripId/joinTrip/:token?" element={<JoinTripConfirmation />} />
      <Route
        path="*"
        element={
          <StatusScreen
            title="Page not found"
            description="The page you are looking for does not exist."
            error={true}
          />
        }
      />
    </Routes>
  )
}
